<template>
  <svg
    id="icon-back"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 17 16"
  >
    <path
      d="M4.75 8.004c0-.269.115-.506.354-.712l6.894-6.023c.195-.174.442-.269.726-.269.575 0 1.026.403 1.026.917a.905.905 0 0 1-.31.664L7.22 8.004l6.221 5.423c.195.174.31.41.31.664 0 .506-.451.909-1.027.909-.292 0-.53-.087-.725-.26L5.104 8.714c-.239-.197-.354-.442-.354-.711Z"
      :fill="fill"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M.875.8c.483 0 .875.393.875.876v12.65a.875.875 0 0 1-1.75 0V1.675C0 1.193.392.8.875.8Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "./mixins/icons";

export default {
  name: "IconBack",
  mixins: [iconPropsFunc()],
};
</script>
